module.exports = __webpack_public_path__ + "img/logo.38e20e9c.jpeg";